module.exports = __webpack_public_path__ + "img/top.0f6c0099.svg";